import { render, staticRenderFns } from "./CrewActivityComment.vue?vue&type=template&id=142f0d07&scoped=true&"
import script from "./CrewActivityComment.vue?vue&type=script&lang=js&"
export * from "./CrewActivityComment.vue?vue&type=script&lang=js&"
import style0 from "./CrewActivityComment.vue?vue&type=style&index=0&id=142f0d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f0d07",
  null
  
)

export default component.exports